module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.brasterAllowed) ? _c('div', {
    staticClass: "info__wrapper"
  }, [_c('img', {
    staticClass: "info__icon",
    attrs: {
      "src": require("../../../assets/images/icons/ico-ok-green.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info__status"
  }, [_vm._v(_vm._s(_vm.$t('YES')))]), _vm._v(" "), _c('a', {
    staticClass: "arrow-link",
    on: {
      "click": function($event) {
        return _vm.initiate()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('CHECK_IF_DATA_ACTUAL')) + "\n            "), _c('img', {
    staticClass: "link__img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })])]) : _c('div', {
    staticClass: "info__wrapper"
  }, [_c('img', {
    staticClass: "info__icon",
    attrs: {
      "src": require("../../../assets/images/icons/ico-not-ok.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info__status"
  }, [_vm._v(_vm._s(_vm.$t('NO')))]), _vm._v(" "), _c('a', {
    staticClass: "arrow-link",
    on: {
      "click": function($event) {
        return _vm.initiate()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('CHECK_IF_DATA_ACTUAL')) + "\n            "), _c('img', {
    staticClass: "link__img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })])]), _vm._v(" "), (_vm.checkIfAllowed) ? _c('section', [(_vm.survey.section2.active_section === 1) ? _c('survey-step2-q1', {
    attrs: {
      "single": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.survey.section2.active_section === 2) ? _c('survey-step2-q2', {
    attrs: {
      "single": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.survey.section2.active_section === 3) ? _c('survey-step2-q3', {
    attrs: {
      "single": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.survey.section2.active_section === 4) ? _c('survey-step2-q4', {
    attrs: {
      "single": true,
      "type": "inline"
    },
    on: {
      "close": function($event) {
        return _vm.hideInfoSection(true)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.survey.section2.disallow_by_pregnant) ? _c('survey-disallowed-by-pregnant', {
    on: {
      "close": function($event) {
        return _vm.hideInfoSection(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.survey.section2.disallow_by_breast_cancer) ? _c('survey-disallowed-by-breast-cancer', {
    on: {
      "close": function($event) {
        return _vm.hideInfoSection(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.survey.section2.disallow_by_breast_surgery) ? _c('survey-disallowed-by-breast-surgery', {
    on: {
      "close": function($event) {
        return _vm.hideInfoSection(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.survey.section2.disallow_by_breast_enlargement) ? _c('survey-disallowed-by-breast-enlargament', {
    on: {
      "close": function($event) {
        return _vm.hideInfoSection(false)
      }
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f67e05aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/my-data/braster-allowed.vue
// module id = 1246
// module chunks = 0